import React,{ Component } from 'react';
import { Row, Col, ButtonGroup, Button, Alert } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import countriesObj from "../../../../data/countries";
import { handleFieldChange } from "../../../../Utils";
import moment from "moment";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alert: null,
            dateFrom: '',
            dateTo: '',
            affid: null,
            subid: null,
            country: null,
            partner: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm(type);
        const filters = Object.assign({}, this.state);

        if (filters.compareDateFrom && filters.compareDateTo) filters.compare = 1;

        if (isValid) {
            if (type === "all") {
                const messages = [ `Dates: "${filters.dateFrom}" - "${filters.dateTo}"` ];

                if (filters.affid) messages.push(`Affids: ${filters.affid.map((x) => `"${x}"`)}`)
                if (filters.subid) messages.push(`Subids: ${filters.subid.map((x) => `"${x}"`)}`)
                if (filters.country) messages.push(`Countries: ${filters.country.map((x) => `"${x}"`)}`)
                if (filters.partner) messages.push(`Partners: ${filters.partner.map((x) => `"${x}"`)}`)

                if (!window.confirm(`Are you sure to fetch data for: ${messages.map((message) => `\n${message}`)}`)) return false;
            }

            this.props.onSubmit(filters, type);
        }
    }

    validateForm(type) {
        const { dateFrom, dateTo, compareDateFrom, compareDateTo, alert: stateAlert, ...filters } = this.state;

        let alert = null;

        if (!dateFrom || !dateTo) {
            alert = 'Please set Date';
        } else if (type === 'all') {
            const period = moment(dateTo).diff(moment(dateFrom), 'day');

            console.log('DIFF', period);

            if (filters.affid && filters.country) {
                if (period > 31) alert = 'Please set smaller period of time (up to 31 days).';
            }  else if (filters.partner && filters.subid && filters.country) {
                if (period > 31) alert = 'Please set smaller period of time (up to 31 days).';
            } else if (filters.partner && filters.country) {
                if (period > 7) alert = 'Please set smaller period of time (up to 7 days).';
            } else if (filters.partner && filters.subid) {
                if (period > 7) alert = 'Please set smaller period of time (up to 7 days).';
            } else if (period > 0) {
                alert = 'Please set smaller period of time (up to 1 day).';
            } else if (!Object.values(filters).some((x) => x !== null)) {
                alert = "Select one of the filters: subid, affid, country, partner";
            }
        }

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="compareDateFrom"
                            label="Compare Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.compareDateFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="compareDateTo"
                            label="Compare Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.compareDateTo}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.partnerValues}
                            label="Partner:"
                            name="partner"
                            onChange={this.handleFieldChange}
                            value={this.state.partner}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesObj}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                </Row>
                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('affid')}>Load Affid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('subid')}>Load Subid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('country')}>Load Country</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('all')}>Load All</Button>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit('')}>Load Report</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/AdkDailyV3/components/Form/index.js